import documentsSidebarMenuActionCreators from "Areas/Sidebar/Documents/redux/actionCreators";
import { getNavigateToId } from "Areas/Sidebar/Documents/redux/selectors";
import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getTableFilters, getTableSortOptions } from "../redux/selectors";
import TableInner from "./table.inner";
const mapStateToProps = (state) => ({
    navigateToId: getNavigateToId(state),
    tableFilters: getTableFilters(state),
    tableSortOptions: getTableSortOptions(state)
});
const mapDispatchToProps = (dispatch) => ({
    onResetNavigateTo: () => dispatch(documentsSidebarMenuActionCreators.setNavigateTo(undefined)),
    onSetTableFilters: (documentId, filtersJson) => dispatch(actionCreators.setTableFilters(documentId, filtersJson)),
    onSetTableSortOptions: (documentId, dataField, sortOrder) => dispatch(actionCreators.setTableSortOptions(documentId, dataField, sortOrder))
});
export default connect(mapStateToProps, mapDispatchToProps)(TableInner);
